package com.shmbles.web.util

import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.w3c.dom.events.EventListener

@Composable
fun ObserveViewportEntered(
    sectionId: String,
    distanceFromTop: Double = 700.0,
    onViewportEntered: () -> Unit
) {
    var entered by remember { mutableStateOf(false) }

    LaunchedEffect(sectionId) {
        val check = {
            val el = document.getElementById(sectionId)
            val rect = el?.getBoundingClientRect()
            if (rect != null) {
                val threshold = (window.innerHeight * 0.85).coerceAtLeast(distanceFromTop)
                if (rect.top < threshold && rect.bottom > 0) {
                    if (!entered) {
                        entered = true
                        onViewportEntered()
                    }
                }
            }
        }

        val listener = EventListener { check() }
        window.addEventListener("scroll", listener)
        document.addEventListener("scroll", listener)
        window.addEventListener("touchmove", listener)

        delay(150)
        check()
    }
}

suspend fun animateNumbers(
    number: Int,
    delay: Long = 12L,
    onUpdate: (Int) -> Unit
) {
    (0..number).forEach {
        delay(delay)
        onUpdate(it)
    }
}